export const Utils = {
  dialogOnCloseReasons: ["escapeKeyDown", "backdropClick"],
  limit: {
    bmi: {
      min: 18,
      max: 32,
    },
    digits: {
      aadhaar_number: 12,
      appointee_mobile: 10,
      appointee_name: 30,
      appointee_bank_account_holder_name: 30,
      appointee_bank_ifsc_code: 11,
      address: 50,
      annual_income: 7,
      bank_account_number: 18,
      nominee_bank_account_number: 18,
      appointee_bank_account_number: 18,
      bank_ifsc_code: 11,
      einsurance_account_number: 13,
      mobile: 10,
      name: 30,
      nominee_mobile: 10,
      nominee_name: 30,
      nominee_bank_account_holder_name: 30,
      nominee_bank_ifsc_code: 11,
      open_text_field: 50,
      otp: 6,
      pan_number: 10,
      pincode: 6,
    },
    height: {
      min: 90,
      max: 210,
    },
    weight: {
      min: 40,
      max: 150,
    },
  },
  regex: {
    // pan_number: /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/,
    aadhaar_number:
      /^([0-9]{4}[0-9]{4}[0-9]{4}$)|([0-9]{4}\s[0-9]{4}\s[0-9]{4}$)|([0-9]{4}-[0-9]{4}-[0-9]{4}$)/,
  },
};
